export default {
    // baseURL: 'http://localhost:8000/',
    baseURL: 'https://poly.farmlinkrural.com/'
}
